import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {};

function OBSERVER_ADD(state, action) {
	const { observerId, userId, alertRate, alertHistory, email, firstName, lastName } = action;
	if (
		!observerId ||
		userId === null ||
		userId === undefined ||
		alertRate === null ||
		alertRate === undefined ||
		alertHistory === null ||
		alertHistory === undefined ||
		(!email && !firstName && !lastName)
	) {
		return state;
	}

	return {
		...state,
		[observerId]: {
			__id: observerId,
			userId,
			alertRate,
			alertHistory,
			email,
			firstName,
			lastName,
		},
	};
}

function OBSERVER_ADD_MULTIPLE(state, action) {
	const { observers } = action;
	if (!observers || !observers.length) {
		return state;
	}

	let nextState = state;
	observers.forEach(o => {
		nextState = OBSERVER_ADD(nextState, o);
	});

	return nextState;
}

function OBSERVER_REMOVE_MULTIPLE(state, action) {
	const { observerIds } = action;
	if (!observerIds || !observerIds.length) {
		return state;
	}

	const nextState = { ...state };
	observerIds.forEach(id => {
		delete nextState[id];
	});
	return nextState;
}

function OBSERVER_UPDATE(state, action) {
	const { id, alertRate, alertHistory, email, firstName, lastName } = action;

	if (!id) {
		return state;
	}

	if (
		(alertHistory === null || alertHistory === undefined) &&
		(alertRate === null || alertRate === undefined) &&
		(email === null || email === undefined) &&
		(firstName === null || firstName === undefined) &&
		(lastName === null || lastName === undefined)
	) {
		return state;
	}

	const currentObserver = state[id];
	if (!currentObserver) {
		return state;
	}

	const nextObserver = {
		__id: id,
		alertHistory:
			alertHistory !== null && alertHistory !== undefined
				? alertHistory
				: currentObserver.alertHistory,
		alertRate:
			alertRate !== null && alertRate !== undefined ? alertRate : currentObserver.alertRate,
		email: email !== null && email !== undefined ? email : currentObserver.email,
		firstName:
			firstName !== null && firstName !== undefined ? firstName : currentObserver.firstName,
		lastName: lastName !== null && lastName !== undefined ? lastName : currentObserver.lastName,
		userId: currentObserver.userId,
	};

	return {
		...state,
		[id]: nextObserver,
	};
}

function OBSERVER_UPDATE_MULTIPLE(state, action) {
	const { observerIds, alertRate, alertHistory } = action;
	if (
		!observerIds ||
		!observerIds.length ||
		(!alertRate && (alertHistory === null || alertHistory === undefined))
	) {
		return state;
	}

	let nextState = state;
	observerIds.forEach(id => {
		nextState = OBSERVER_UPDATE(nextState, { id, alertRate, alertHistory });
	});

	return nextState;
}

const handlers = {};
handlers[actionTypes.OBSERVER_ADD] = OBSERVER_ADD;
handlers[actionTypes.OBSERVER_ADD_MULTIPLE] = OBSERVER_ADD_MULTIPLE;
handlers[actionTypes.OBSERVER_REMOVE_MULTIPLE] = OBSERVER_REMOVE_MULTIPLE;
handlers[actionTypes.OBSERVER_UPDATE] = OBSERVER_UPDATE;
handlers[actionTypes.OBSERVER_UPDATE_MULTIPLE] = OBSERVER_UPDATE_MULTIPLE;
export default createReducer(defaultState, handlers);
